export default {
  objective: '目标',
  keyResult: '实现路径',
  startDay: '启动时间',
  finishDay: '计划完成时间',
  indicator: '指标',
  weight: '权重',
  proportion: '占比',
  progress: '进度',
  align: '对齐',
  state: '状态',
  ok: '确定',
  cancel: '取消',
  delete: '删除',
  reset: '重置',
  createDialog: {
    ok: '创建',
    cancelWarning: '当前编辑中的内容将不会保存，是否确认退出编辑？'
  },
  editDialog: {
    ok: '保存',
    cancelWarning: '当前编辑中的内容将不会保存，是否确认退出编辑？'
  },
  deleteDialog: {
    ok: '确认删除'
  },
  searchInputPlaceHolder: '请输入花名或者姓名进行搜索',
  frequentContacts: '常用联系人',
  noData: '暂无数据',
  noPermission: '无权限查看',
  backToOld: '返回旧版查看'
}
